// GENERATED by reddit-devvit/scripts/gen-share-pages.js (🔗 10-01 event links). Do not edit:
// re-run `node scripts/gen-share-pages.js` from reddit-devvit/ (smoke-share-pages.js
// fails when this drifts). Nights keyed `${day}|${kind}` (house + sky rows only);
// every slug has public/e/<slug>.html. APPEND-ONLY: a shipped page never leaves.
export const SHARE_PAGES = {
  "version": 1,
  "site": "https://myspaice.ai",
  "image_base": "https://spaceexplorer-content-files.s3.us-east-1.amazonaws.com/og/house/v1",
  "nights": {
    "2026-10-02|house": {
      "day": "2026-10-02",
      "kind": "house",
      "template": "apple_picking",
      "label": "Apple picking",
      "at": "2026-10-02T23:00:00.000Z",
      "doors_at": "2026-10-02T22:30:00.000Z",
      "when_text": "4pm Phoenix / 7pm ET",
      "doors_text": "3:30pm Phoenix / 6:30pm ET",
      "room": "orchard",
      "slug": "apple-picking-oct-2",
      "end_at": "2026-10-03T03:30:00.000Z"
    },
    "2026-10-03|house": {
      "day": "2026-10-03",
      "kind": "house",
      "template": "apple_picking",
      "label": "Apple picking",
      "at": "2026-10-03T23:00:00.000Z",
      "doors_at": "2026-10-03T22:30:00.000Z",
      "when_text": "4pm Phoenix / 7pm ET",
      "doors_text": "3:30pm Phoenix / 6:30pm ET",
      "room": "orchard",
      "slug": "apple-picking-oct-3",
      "moved_to": "apple-picking-oct-2"
    },
    "2026-10-08|sky": {
      "day": "2026-10-08",
      "kind": "sky",
      "template": "meteor_shower",
      "label": "Draconids meteor shower",
      "at": "2026-10-09T03:00:00.000Z",
      "doors_at": null,
      "when_text": "8pm Phoenix / 11pm ET",
      "doors_text": null,
      "room": "roof",
      "slug": "draconids-oct-8"
    },
    "2026-10-21|sky": {
      "day": "2026-10-21",
      "kind": "sky",
      "template": "meteor_shower",
      "label": "Orionids meteor shower",
      "at": "2026-10-22T03:00:00.000Z",
      "doors_at": null,
      "when_text": "8pm Phoenix / 11pm ET",
      "doors_text": null,
      "room": "roof",
      "slug": "orionids-oct-21"
    },
    "2026-10-25|sky": {
      "day": "2026-10-25",
      "kind": "sky",
      "template": "moon_viewing",
      "label": "Hunter's Moon night",
      "at": "2026-10-26T02:00:00.000Z",
      "doors_at": null,
      "when_text": "7pm Phoenix / 10pm ET",
      "doors_text": null,
      "room": "roof",
      "slug": "hunters-moon-oct-25"
    },
    "2026-10-27|house": {
      "day": "2026-10-27",
      "kind": "house",
      "template": "seance_night",
      "label": "Seance night",
      "at": "2026-10-28T02:00:00.000Z",
      "doors_at": null,
      "when_text": "7pm Phoenix / 10pm ET",
      "doors_text": null,
      "room": "attic",
      "slug": "seance-night-oct-27"
    },
    "2026-10-28|house": {
      "day": "2026-10-28",
      "kind": "house",
      "template": "book_club",
      "label": "Book club",
      "at": "2026-10-29T02:00:00.000Z",
      "doors_at": null,
      "when_text": "7pm Phoenix / 10pm ET",
      "doors_text": null,
      "room": "library",
      "slug": "book-club-oct-28"
    },
    "2026-10-30|house": {
      "day": "2026-10-30",
      "kind": "house",
      "template": "costume_contest",
      "label": "Costume contest",
      "at": "2026-10-30T22:00:00.000Z",
      "doors_at": null,
      "when_text": "3pm Phoenix / 6pm ET",
      "doors_text": null,
      "room": null,
      "slug": "costume-contest-oct-30"
    },
    "2026-10-31|house": {
      "day": "2026-10-31",
      "kind": "house",
      "template": "trick_or_treat",
      "label": "Trick or treat",
      "at": "2026-11-01T00:00:00.000Z",
      "doors_at": null,
      "when_text": "5pm Phoenix / 8pm ET",
      "doors_text": null,
      "room": null,
      "slug": "trick-or-treat-oct-31"
    },
    "2026-11-17|sky": {
      "day": "2026-11-17",
      "kind": "sky",
      "template": "meteor_shower",
      "label": "Leonids meteor shower",
      "at": "2026-11-18T03:00:00.000Z",
      "doors_at": null,
      "when_text": "8pm Phoenix / 10pm ET",
      "doors_text": null,
      "room": "roof",
      "slug": "leonids-nov-17"
    },
    "2026-11-26|house": {
      "day": "2026-11-26",
      "kind": "house",
      "template": "harvest_feast",
      "label": "Harvest feast",
      "at": "2026-11-26T21:00:00.000Z",
      "doors_at": null,
      "when_text": "2pm Phoenix / 4pm ET",
      "doors_text": null,
      "room": "dining",
      "slug": "harvest-feast-nov-26"
    },
    "2026-12-13|sky": {
      "day": "2026-12-13",
      "kind": "sky",
      "template": "meteor_shower",
      "label": "Geminids meteor shower",
      "at": "2026-12-14T03:00:00.000Z",
      "doors_at": null,
      "when_text": "8pm Phoenix / 10pm ET",
      "doors_text": null,
      "room": "roof",
      "slug": "geminids-dec-13"
    },
    "2026-12-23|sky": {
      "day": "2026-12-23",
      "kind": "sky",
      "template": "moon_viewing",
      "label": "Cold Moon night",
      "at": "2026-12-24T02:00:00.000Z",
      "doors_at": null,
      "when_text": "7pm Phoenix / 9pm ET",
      "doors_text": null,
      "room": "roof",
      "slug": "cold-moon-dec-23"
    },
    "2026-12-31|sky": {
      "day": "2026-12-31",
      "kind": "sky",
      "template": "fireworks_night",
      "label": "Fireworks night",
      "at": "2027-01-01T02:00:00.000Z",
      "doors_at": null,
      "when_text": "7pm Phoenix / 9pm ET",
      "doors_text": null,
      "room": "roof",
      "slug": "fireworks-night-dec-31"
    },
    "2027-01-03|sky": {
      "day": "2027-01-03",
      "kind": "sky",
      "template": "meteor_shower",
      "label": "Quadrantids meteor shower",
      "at": "2027-01-04T03:00:00.000Z",
      "doors_at": null,
      "when_text": "8pm Phoenix / 10pm ET",
      "doors_text": null,
      "room": "roof",
      "slug": "quadrantids-jan-3"
    },
    "2027-01-22|sky": {
      "day": "2027-01-22",
      "kind": "sky",
      "template": "moon_viewing",
      "label": "Wolf Moon night",
      "at": "2027-01-23T02:00:00.000Z",
      "doors_at": null,
      "when_text": "7pm Phoenix / 9pm ET",
      "doors_text": null,
      "room": "roof",
      "slug": "wolf-moon-jan-22"
    }
  },
  "templates": {},
  "rooms": {}
};

export default SHARE_PAGES;
